import React from 'react';
import './HomeSearch.css';

import { useTourFilter } from '../../../utils';
import { ToursSearch } from '../../../components';



const HomeSearch = () => {

  // Use the useTourFilter hook to manage filtering and pagination
  const { handleFormSubmit } = useTourFilter();

  return (

    <div className='home-search'>

      {/* Render the CarSearch component and pass the handleFormSubmit function */}
      <ToursSearch onFormSubmit={handleFormSubmit} />

    </div>

  );
};

export default HomeSearch;